import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";

export class AbstractDialogPlayerOptionsMediator {
    constructor() {
        this._dialogPlayer;
        
        this._onDialogOptionsChangedBound = this._onDialogOptionsChanged.bind(this);      
        this._onDialogOptionChosenBound = this._onDialogOptionChosen.bind(this);
        this._onDialogEndBound = this._onDialogEnd.bind(this);
    }

    destroy() {
        this._removeDialogPlayerListeners();
    }

    // ------------------------------------------
    //  Abstract functions (to override)
    // ------------------------------------------
    _handleDialogOptionsChanged() {}

    // ------------------------------------------
    //  Dialog listeners
    // ------------------------------------------
    _addDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;
        
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    _removeDialogPlayerListeners() {
        if (isNull(this._dialogPlayer)) return;
        
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTIONS_CHANGED, this._onDialogOptionsChangedBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_OPTION_CHOSEN, this._onDialogOptionChosenBound);
        this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.DIALOG_END, this._onDialogEndBound);
    }

    // ------------------------------------------
    //  Dialog handlers
    // ------------------------------------------
    _onDialogOptionsChanged(event) {
        this._handleDialogOptionsChanged();
    }

    _onDialogOptionChosen({params}) {
       this._handleDialogOptionChosen(params.data.option);
   }

    _onDialogEnd(event) {
        this.setDialogPlayer(null);
    }

    // ------------------------------------------
    // Content delegates
    // ------------------------------------------

    getDialogPlayer() {
         return this._dialogPlayer;
     }

    setDialogPlayer(value) {
        if (! isNull(this._dialogPlayer)) {
            this._removeDialogPlayerListeners();         
        }
                 
        this._dialogPlayer = value;
        
        if (this._dialogPlayer !== null) {
            this._addDialogPlayerListeners();
        }
    }
}
     
     


